import axios, { AxiosRequestConfig } from "axios";
import appconfig from "../../AppConfig";
import { SET_CONVERSION_RATE } from "../common.actions";

export const getConversionRateApi = async (dispatch: any): Promise<boolean> => {
  const config = {
    baseURL: appconfig.baseURL,
  } as AxiosRequestConfig;

  try {
    const response = await axios.get("/settings/getConversionRate", config);
    dispatch({
      type: SET_CONVERSION_RATE,
      conversionRate: parseFloat(response.data.rate),
    });
    return true;
  } catch (err) {
    console.log(err);
    return false;
  }
};
